import React from "react";

const ShareIcon = () => {
  return (
    <svg
      className="share"
      width="17"
      height="20"
      viewBox="0 0 17 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <circle
          fill="#E46173"
          transform="rotate(90 13.816 3.948)"
          cx="13.816"
          cy="3.948"
          r="3"
        />
        <circle
          fill="#E46173"
          transform="rotate(90 3.438 10.448)"
          cx="3.438"
          cy="10.448"
          r="3"
        />
        <path
          d="M4.162 9.448l9-5M4.43 10.948l4.158 2.494 4.67 2.8"
          stroke="#E46173"
          strokeWidth="1.5"
          strokeLinecap="square"
        />
        <circle
          fill="#E46173"
          transform="rotate(90 13.816 16.948)"
          cx="13.816"
          cy="16.948"
          r="3"
        />
      </g>
    </svg>
  );
};

export default ShareIcon;
